import React from 'react'
import { toast } from 'react-toastify'
import Text from '../../../components/Text'
import Button from '../../../components/Button'
import Axios from 'axios'
import { useAuth } from '@polvo-labs/react-auth'


interface Props {

}


const ActivateWelcomeScreen: React.FC<Props> = () => {

  var getEmail = sessionStorage.getItem("email");
  var getId = sessionStorage.getItem("id");
  
  const { token, user } = useAuth();

  if ( user ){
    getEmail = user.email
    getId = user.id
  }


  return (
    <div>
      <Text tag="h1">
        Bem-vindo ao IPTU Dívida ativa. Sua conta foi criada com sucesso!
      </Text>
      <Text tag="p">
        <p>
          Agora você pode acessa-la utilizando seu login e senha. <br /><br /> 
          Enviamos um e-mail para você confirmar seu cadastro no endereço: <strong> { getEmail }  </strong> <br />
          Caso não o encontre verifique na sua pasta de lixo electrõnico (SPAM).
        </p>
        </Text>  

     <Button
        label="Reenviar e-mail"
        onClick={(evt: any) => {
          Axios({
            method: 'GET',
            url: `${process.env.REACT_APP_API_URL}/email/resend/${getId}`,
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }).then(({ data }) => {
            toast.success(data.message)
          }).catch(() => {
            toast.error('Ocorreu um erro, verifique sua conexão com a Internet')
          })
        }}
      >
      </Button>

    </div>
  )
}

export default ActivateWelcomeScreen
